import { Type } from '@angular/core';

export interface OnLoaded {
  /**
   * If the component has finished loading and is ready to use.
   */
  ready(): Promise<void>;
}

export type OnLoadedComponent = Type<unknown> | OnLoaded;

export function hasOnLoadedImplementation(
  instance: OnLoaded,
): instance is OnLoaded {
  return typeof instance.ready === 'function';
}
